// extracted by mini-css-extract-plugin
export default {"count":"Counter_count__uLFwT","number":"Counter_number__iCoym"};